import type TurndownService from 'turndown';

function isBulletItem(node: HTMLElement): boolean {
  const dataList = node.getAttribute('data-list');

  if (dataList === 'bullet') return true;

  if (dataList === 'ordered') return false;

  return node.parentNode?.nodeName === 'UL';
}

const listItem: TurndownService.Rule = {
  filter: 'li',
  replacement: (content, node, options) => {
    const body = content.replace(/^\n+/, '').replace(/\n+$/, '\n').replace(/\n/gm, '\n    ');

    let prefix = `${options.bulletListMarker}   `;

    if (!isBulletItem(node)) {
      const parent = node.parentNode as HTMLElement;
      const start = parent.getAttribute?.('start');
      const siblings = Array.from(parent.children);
      const orderedBefore = siblings
        .slice(0, siblings.indexOf(node))
        .filter(sibling => !isBulletItem(sibling as HTMLElement)).length;
      const number = start ? Number(start) + orderedBefore : orderedBefore + 1;

      prefix = `${number}.  `;
    }

    const suffix = node.nextSibling && !/\n$/.test(content) ? '\n' : '';

    return prefix + body + suffix;
  },
};

export const turndownQuillLists: TurndownService.Plugin = turndownService => {
  turndownService.addRule('quillListItem', listItem);
};
